import template from './fixedFeeBasisModal.html';
import controller from './fixedFeeBasisModal.controller';

let FixedFeeBasisModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

export default FixedFeeBasisModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/fixedFeeBasisModal/fixedFeeBasisModal.component.js